var React = require('react');

function IconRecurringBenefit (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Paths"},[React.createElement("path",{"id":"Ellipse 35","d":"M14.1161 5.53581C13.1263 2.94203 10.6197 1.1001 7.68394 1.1001C3.88194 1.1001 0.799805 4.18933 0.799805 8.0001C0.799805 11.8109 3.88194 14.9001 7.68394 14.9001C9.55968 14.9001 11.2602 14.1482 12.5018 12.9287M14.1161 5.53581L15.0598 3.07153M14.1161 5.53581L11.3719 5.04295","stroke":"#A1AAC5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector 37","d":"M7.59961 4.2002V8.4002L10.3996 9.6002","stroke":"#A1AAC5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

IconRecurringBenefit.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconRecurringBenefit;

IconRecurringBenefit.default = IconRecurringBenefit;
